













import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'AuthSwitcherMobile',
  computed: {
    isLogin() {
      return this.$route.path === '/login';
    }
  }
})
export default class AuthSwitcherMobile extends Vue {}
